// const ApiUrl = 'http://192.168.16.175:8080';
const ApiUrl = 'https://api-wifi.tdtu.uz';


export {ApiUrl}